import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import SingleComment from "./Comment/SingleComment";
import { withdrawCommentsListUrl } from "../Withdraw/Config";

const LoadmoreComments = () => {

  const { comments } = useStaticQuery(graphql`
    {
      comments: allWp {
        nodes {
          fscomments {
            fscomments {
              comment
              emoji
              id
              name
              rating
              request_time
            }
          }
        }
      }
    }
  `);

  const { fscomments } = comments.nodes[0];

  const loadCommentsData = async (page, pageSize, firstcomments, activeComments, setActiveComments, setTotalPages) => {
    if (page === 1) {
      return false;
    }
    const lastWordpressId = (firstcomments.length > 0) ? firstcomments[firstcomments.length - 1].id : false;
    const listingUrl = withdrawCommentsListUrl + `/?per_page=${pageSize}&page=${page}&before_id=${lastWordpressId}`;
    const response = await fetch(listingUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.ok) {
      const totalPages = await response.headers.get('X-WP-TotalPages');
      setTotalPages(totalPages);
      const json = await response.json();

      setActiveComments(activeComments.concat(json));
    }
  };

  const pageSize = 4;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(false);
  const firstcomments = fscomments.fscomments;
  const [activeComments, setActiveComments] = useState(fscomments.fscomments);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    loadCommentsData(page, pageSize, firstcomments, activeComments, setActiveComments, setTotalPages).then(() => {
      setIsLoading(false);
    });
  }, [page]);

  return (
    <div className="user-comments-block dark">
      <div className="wrapper">
        <h3 className="h3 gradient a-center">
          <span>รรีวิวผู้เล่น SbotopBet</span>
        </h3>
        {activeComments.length > 0 &&
        <ul className="user-comments-list">
          {activeComments.map((item) =>
            <SingleComment key={item.id} name={item.name} rating={item.rating} emoji={item.emoji}
                           comment={item.comment} date={item.request_time}/>
          )}
        </ul>
        }

        {((totalPages === false) || (totalPages > page)) &&
        <div className="a-center">
          <button className="button-white" onClick={() => setPage(page + 1)} disabled={isLoading}>
            {isLoading ? "กำลังโหลด ..." : "ความคิดเห็นเพิ่มเติม"}
          </button>
        </div>
        }

        {!activeComments.length &&
        <div>{totalPages * 1 === 0 ? 'ไม่มีความคิดเห็น. เป็นคนแรก' : 'กำลังโหลด ...'}</div>
        }
      </div>
    </div>

  );

};

export default LoadmoreComments;
